import loginService from '../../plugin/extendFn/loginService'
import postHttp from './../../plugin/extendFn/postHttp'

/**
 * 账户必须关注公众号。 没有关注就跳转 。 
 */

function SubscribeGard(to, from, next) {
    console.log("gard >>> SubscribeGard ----------------------------------------");

    var userId=loginService.getUserId();
    if(["SubscribeQRCode","userinfo","Login"].indexOf(to.name)>=0
      || ( userId==null  || userId<=0)  // 未登录状态，不做检查
    )
    {
      // 忽略的路由。 
      next()
    }
    else
    {
        // 检查是否关注了公众号
        /**
         * 1. 必须登录的状态
         * 2. 没有关注就跳转关注
         */
        postHttp(`/ra-app/api/cmdhra/isSubscribe/${userId}`).then(async (res) => {
          console.log("isSubscribe >>> res=", res)
          var code = res.data.code;
          var isSubscribe = res.data.data;
          // 重新加载页面。
          if (code == 0) {
              if(isSubscribe==true)
              {
                // 已经关注
                next()
              }
              else  // 没有关注
              {
                next({
                  name:"SubscribeQRCode"
                })
              }
          }
      })
      
    }
}



export default SubscribeGard;



// WEBPACK FOOTER //
// ./src/router/gard/SubscribeGard.js